type ComparisonSearchParams = Record<string, string | string[] | undefined>;

const getSearchParamValue = (
  searchParams: ComparisonSearchParams,
  key: string
): string | undefined => {
  const value = searchParams[key];
  return Array.isArray(value) ? value[0] : value;
};

export const getComparisonTrackingProps = (
  models: any[],
  searchParams: ComparisonSearchParams,
  isSelfComparison: boolean,
  selectedVariants?: Array<{ variantName?: string } | null>
): Record<string, string> => models.reduce<Record<string, string>>(
  (props, model, index) => {
    const variants = model?.allVariantSlugs?.uniqueSortedVariants || [];
    const requestedVariant = getSearchParamValue(
      searchParams,
      `variant${index + 1}`
    );
    const defaultVariant = isSelfComparison && index === 1
      ? model?.allVariantSlugs?.baseVariant
      : model?.allVariantSlugs?.topVariant;
    const routeSelectedVariant = variants.find(
      (item: { slug?: string }) => item.slug === requestedVariant
    ) || defaultVariant || variants[0];
    const selectedVariant = selectedVariants?.[index] || routeSelectedVariant;
    const mmv = [
      model?.brand?.name,
      model?.model?.name,
      selectedVariant?.variantName,
    ].filter(Boolean).join(" ");

    // mmv_1 is the first comparison entry and also the source of vehicle_*.
    props[`mmv_${index + 1}`] = mmv;
    if (index === 0) {
      props.vehicle_make = model?.brand?.name || "";
      props.vehicle_model = model?.model?.name || "";
      props.vehicle_variant = selectedVariant?.variantName || "";
    }
    return props;
  },
  {}
);
